// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DSW1","footer":"styles_footer__39gVM","passCodeTooltip":"styles_passCodeTooltip__m_UoJ"};